<template>
  <v-list subheader>
    <v-item-group>
      <v-item class="my-2">
        <CardItemsComponents
          v-show="!showBokking"
          :active="true"
          @click="showBokking = !showBokking"
        >
          <template v-slot:icon>
            <v-icon color="primary" v-text="iconWhere" />
          </template>
          <template v-slot:body>
            <v-container fluid fill-height pa-0 ma-0>
              <v-row no-gutters>
                <v-col cols="12">
                  <span
                    class="list-text-title text-o-l-2"
                    v-text="
                      $t('checkout.delivery_to', {
                        street: guestAddress,
                        buildingNo,
                        city,
                      })
                    "
                  />
                </v-col>
              </v-row>
            </v-container>
          </template>

          <template v-slot:actions>
            <v-icon
              v-if="showError"
              color="error"
              v-text="'mdi-alert-circle'"
            />
            <span
              v-else
              class="list-text-change"
              v-text="$t('general.change')"
            />
          </template>
        </CardItemsComponents>
      </v-item>

      <v-item v-show="showBokking" class="list-item">
        <v-item-group
          v-if="$store.getters.checkAuth"
          v-model="whereSelected"
          style="width: 100%"
        >
          <v-expansion-panels focusable flat>
            <template v-if="itemsAddressBook.length > 0">
              <v-item
                v-for="address in itemsAddressBook"
                v-show="whereSelected > 0"
                :key="address.id"
                v-slot="{ active }"
                class="mb-1"
                :value="address.id"
              >
                <v-expansion-panel
                  :v-ripple="!$store.getters.isLoading"
                  readonly
                  :class="{ active: active }"
                  :disabled="$store.getters.isLoading"
                  @click="whereSelected = address.id"
                >
                  <v-expansion-panel-header hide-actions>
                    <v-container fluid pa-0 ma-0>
                      <v-row no-gutters justify="start" align-content="center">
                        <v-icon
                          :color="active ? 'primary' : ''"
                          v-text="
                            active
                              ? 'mdi-check-circle-outline'
                              : 'mdi-checkbox-blank-circle-outline'
                          "
                        />
                        <v-col class="ml-4">
                          <v-container fluid fill-height pa-0 ma-0>
                            <v-row no-gutters>
                              <v-col cols="12">
                                <span
                                  class="list-text-title"
                                  v-text="address.addressTitle"
                                />
                              </v-col>
                              <v-col cols="12" class="pt-1">
                                <span
                                  class="list-text-subtitle"
                                  v-text="address.prettyAddress"
                                />
                              </v-col>
                              <v-col cols="12" class="pt-1">
                                <span
                                  v-if="
                                    active &&
                                    showError &&
                                    !$store.getters.isLoading
                                  "
                                  class="no-deliverable-item"
                                  v-text="addressErrorMessage"
                                />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-expansion-panel-header>
                </v-expansion-panel>
              </v-item>
              <v-item
                v-show="whereSelected > 0"
                :key="0"
                v-slot="{ active }"
                class="mb-1"
                :value="0"
              >
                <v-expansion-panel
                  :v-ripple="!$store.getters.isLoading"
                  readonly
                  :class="{ active: active }"
                  @click="whereSelected = 0"
                >
                  <v-expansion-panel-header hide-actions>
                    <v-container fluid pa-0 ma-0>
                      <v-row no-gutters justify="start" align-content="center">
                        <v-icon
                          :color="active ? 'primary' : ''"
                          v-text="'mdi-plus-circle-outline'"
                        />
                        <v-col class="ml-4">
                          <v-container fluid fill-height pa-0 ma-0>
                            <v-row no-gutters>
                              <v-col cols="12">
                                <span
                                  class="list-text-title"
                                  v-text="$t('customerProfile.addAddress')"
                                />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-expansion-panel-header>
                </v-expansion-panel>
              </v-item>
            </template>
          </v-expansion-panels>
          <v-item v-if="whereSelected == 0" :key="'new'" class="mb-1">
            <v-card
              id="whereSectionIdNewAddress"
              elevation="0"
              :loading="$store.getters.isLoading"
              class="overflow-hidden"
            >
              <FormAddressComponent v-model="formAddressNew" />
              <v-card-actions>
                <v-container>
                  <v-row dense wrap justify="space-between">
                    <v-col>
                      <ButtonSuccess
                        :valid="formAddressNew == false ? false : true"
                        @click="saveAddressBook()"
                      />
                    </v-col>
                    <v-col>
                      <ButtonCancel
                        title="general.cancel"
                        @click="selectDefaultAddress()"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-item>
        </v-item-group>
        <v-item-group v-else style="width: 100%">
          <v-item>
            <v-card
              elevation="0"
              :loading="$store.getters.isLoading"
              class="overflow-hidden"
            >
              <v-form
                ref="FormAddress"
                v-model="validAddressForm"
                :disabled="$store.getters.isLoading"
                class="px-lg-5 pt-4"
              >
                <v-row no-gutters justify="space-between" class="test_blue">
                  <v-col cols="12" class="test_purple px-2">
                    <PlaceAutocompleteInput
                      v-model="components"
                      :label="$t('inputs.dropoff_address')"
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="test_purple px-2">
                    <v-text-field
                      v-model="formAddress.street"
                      :label="$t('inputs.street')"
                      clearable
                      :rules="[$rules.required]"
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="test_purple px-2">
                    <v-text-field
                      v-model="formAddress.buildingNumber"
                      :label="$t('inputs.building_number')"
                      clearable
                      :rules="[$rules.required]"
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="test_purple px-2">
                    <v-text-field
                      v-model="formAddress.postalCode"
                      :label="$t('inputs.postal_code')"
                      clearable
                      :rules="[$rules.required]"
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="test_purple px-2">
                    <v-text-field
                      v-model="formAddress.city"
                      :label="$t('inputs.city')"
                      clearable
                      :rules="[$rules.required]"
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="test_purple px-2">
                    <v-text-field
                      v-model="formAddress.floor"
                      :label="$t('inputs.floor')"
                      clearable
                    />
                  </v-col>
                </v-row>
              </v-form>
              <v-container v-if="showAddressError" fluid>
                <v-banner
                  v-model="showAddressError"
                  single-line
                  transition="slide-y-transition"
                  icon="mdi-map-marker-remove-outline"
                  icon-color="white"
                  color="red"
                >
                  <span class="no-deliverable" v-text="addressErrorMessage" />
                </v-banner>
              </v-container>
              <v-card-actions id="whereSectionId">
                <v-container>
                  <v-row dense wrap justify="space-between">
                    <v-col>
                      <ButtonSuccess
                        :title="
                          valuesChanged
                            ? $t('general.change')
                            : $t('general.confirm')
                        "
                        :valid="!disableBtn"
                        :is-loading="isSavingAddress"
                        @click="saveAddress()"
                      />
                    </v-col>
                    <v-col>
                      <ButtonCancel
                        title="general.delete"
                        :valid="validAddressForm"
                        :disabled-loading="true"
                        @click="removeAddress()"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-item>
        </v-item-group>
      </v-item>
    </v-item-group>
  </v-list>
</template>

<script>
/*
Actions:
  If there are address, fill the form
  Delete address
  Validate checkoutValidator.deliveryInfo:
    Mount
    When the addres change
  Showerror from getters
*/
import { FormAddressComponent } from "../../../profile/components";
export default {
  name: "WhereSection",
  components: {
    FormAddressComponent,
  },
  data: () => ({
    showBokking: true,
    components: null,
    valid: false,
    valuesChanged: false,
    isSavingAddress: false,
    validAddressForm: false,
    formAddressNew: false,
    formAddress: new Form({
      prettyAddress: null,
      street: null,
      buildingNumber: null,
      postalCode: null,
      city: null,
      floor: "",
    }),
    showAddressError: false,
    whereSelected: 0,
    itemsAddressBook: [],
    types: [
      { name: "Home", icon: "mdi-home" },
      { name: "Office", icon: "mdi-city" },
      { name: "Custom", icon: "mdi-home-outline" },
    ],
  }),
  computed: {
    guestAddress: {
      get() {
        if (this.$store.getters.guestAddress) {
          this.formAddress.keys().forEach((key) => {
            this.formAddress[key] = this.$store.getters.guestAddress[key];
          });
          return this.$store.getters.guestAddress.street;
        } else {
          return this.$t("checkout.some_address");
        }
      },
      set(val) {
        return val;
      },
    },
    buildingNo: {
      get() {
        if (this.$store.getters.guestAddress) {
          return this.$store.getters.guestAddress.buildingNumber;
        } else {
          return "";
        }
      },
      set(val) {
        return val;
      },
    },
    city: {
      get() {
        if (this.$store.getters.guestAddress) {
          return this.$store.getters.guestAddress.city;
        } else {
          return "";
        }
      },
      set(val) {
        return val;
      },
    },
    iconWhere: function () {
      if (this.$store.getters.guestAddress) {
        let found = this.types.find(
          (item) => item.name === this.$store.getters.guestAddress.addressTitle
        );
        return found.icon;
      } else {
        return "mdi-home-outline";
      }
    },
    showDeleteAddress: {
      get() {
        if (this.$store.getters.guestAddress) {
          return true;
        } else {
          return false;
        }
      },
      set(val) {
        return val;
      },
    },
    showError: function () {
      return !this.$store.getters.checkoutValidation.deliveryInfo.status;
    },
    disableBtn: function () {
      return this.showAddressError
        ? true
        : !this.validAddressForm || this.$store.getters.isLoading;
    },
    addressErrorMessage: {
      get() {
        return this.$t("checkout.AddressDeliveryZone");
      },
      set(val) {
        return val;
      },
    },
  },
  watch: {
    formAddress: {
      handler() {
        this.valuesChanged = false;
      },
      deep: true,
    },
    components: function () {
      this.showAddressError = false;
      if (this.components) {
        this.formAddress.street = this.components.street;

        this.formAddress.keys().forEach((key) => {
          this.formAddress[key] = this.components[key];
        });
        // setTimeout(() => {
        //   document
        //     .getElementById("whereSectionId")
        //     .scrollIntoView({ behavior: "smooth" });
        // }, 500);
      } else {
        this.formAddress.keys().forEach((key) => {
          this.formAddress[key] = null;
          this.showAddressError = false;
        });
      }
    },
    whereSelected: function () {
      if (this.whereSelected > 0) {
        this.$store.dispatch("delivery/removeDeliveryDetails");
        this.$store.dispatch("loading/start");

        this.saveAddress();
      }
    },
    "$store.getters.checkAuth": function () {
      if (this.$store.getters.checkAuth) {
        this.loadAddressBook();
      } else {
        this.formAddress.reset();
        this.validAddressForm = false;
        this.whereSelected = 0;
        this.itemsAddressBook = [];
        this.showAddressError = false;
      }
    },
  },
  beforeDestroy() {
    this.$store.dispatch("guest/removeAddress");
  },
  mounted() {
    if (this.$store.getters.checkAuth) {
      this.loadAddressBook();
    }
  },
  methods: {
    loadAddressBook: async function (id = null) {
      const self = this;
      const { data } = await axios.get("/users/profiles/address/book");
      self.itemsAddressBook = data.data;
      if (data.data.length > 0) {
        if (id) {
          self.whereSelected = id;
        } else {
          if (self.whereSelected == 0 || self.whereSelected == undefined) {
            self.selectDefaultAddress();
          }
        }
      } else {
        self.whereSelected = 0;
      }
    },
    selectDefaultAddress: async function () {
      const self = this;
      if (self.itemsAddressBook.length > 0) {
        let found = self.itemsAddressBook.find((item) => item.isDefault == 1);
        if (found) {
          self.whereSelected = found.id;
        } else {
          //TODO: if there is not default address
          self.whereSelected = self.itemsAddressBook[0].id;
        }
      } else {
        self.whereSelected = 0;
      }
    },
    saveAddress: async function () {
      const self = this;
      // self.$store.dispatch("loading/start");
      self.isSavingAddress = true;
      let adderss;
      //check delivery
      self.messageAddressNoDeliverable = null;
      // now if is loggin
      if (self.$store.getters.checkAuth) {
        let found = self.itemsAddressBook.find(
          (item) => item.id === self.whereSelected
        );
        adderss = {
          addressTitle: found.addressTitle,
          street: found.streetName,
          postalCode: found.postCode,
          city: found.city,
          buildingNumber: found.buildingNo,
          floor: found.floor,
        };
      } else {
        adderss = {
          addressTitle: "Custom",
          street: self.formAddress.street,
          postalCode: self.formAddress.postalCode,
          city: self.formAddress.city,
          buildingNumber: self.formAddress.buildingNumber,
          floor: self.formAddress.floor,
        };
      }

      const { data } = await axios.get("/app/orders/address/check", {
        params: {
          storeId: self.$store.getters.storeInfo.id,
          streetName: adderss.street,
          postCode: adderss.postalCode,
          city: adderss.city,
          buildingNo: adderss.buildingNumber,
          floor: adderss.floor,
          schedule_time: self.$store.getters.deliveryDropoffDateTime ?? null,
          subTotal: self.$store.getters.cartDetails.subTotal,
          sessionId: self.$store.getters.guestSessionId,
        },
      });
      self.valuesChanged = true;
      let addresDatas = data.data;
      self.$store.dispatch("delivery/setDeliveryAddressCheckDetails", {
        non_deliverable_reason:
          addresDatas?.non_deliverable_reason ?? undefined,
        non_deliverable_error: addresDatas?.non_deliverable_error ?? undefined,
      });

      if (addresDatas.is_deliverable) {
        let estimationFormCheck = {
          storeId: self.$store.getters.storeInfo.id,
          orderType: "delivery-service",
        };
        const { data } = await axios.get("/app/orders/estimation/check", {
          params: estimationFormCheck,
        });
        let estimationDatas = data.data;
        self.$store.dispatch("guest/setAddress", adderss);
        let info = {
          distance: addresDatas.distanceUnit,
          price: addresDatas.deliveryPrice,
          time: estimationDatas.asap,
          estimatedTime: addresDatas?.estimated_minutes ?? undefined,
        };
        self.$store.dispatch("delivery/setDeliveryDetails", info);
        self.$store.dispatch("delivery/removeDeliveryAddressCheckDetails");
        self.$store.dispatch("cart/setLoad");
        self.showBokking = true;
      } else if (addresDatas?.non_deliverable_reason === "delivery-zone") {
        self.$store.dispatch("guest/removeAddress");
        self.$store.dispatch("delivery/removeDeliveryDetails");
        self.showAddressError = true;
      } else if (addresDatas?.non_deliverable_reason === "schedule-time") {
        self.showAddressError = false;
      } else {
        self.$store.dispatch("guest/removeAddress");
        self.$store.dispatch("delivery/removeDeliveryDetails");
        self.showAddressError = true;
      }

      self.$store.dispatch("loading/done");
      self.isSavingAddress = false;
      setTimeout(() => {
        self.valuesChanged = true;
      }, 50);
    },
    removeAddress: function () {
      const self = this;
      self.$store.dispatch("loading/start");

      self.$store.dispatch("guest/removeAddress");
      self.$store.dispatch("delivery/removeDeliveryDetails");
      self.$store.dispatch("delivery/removeDeliveryAddressCheckDetails");
      setTimeout(() => {
        self.$store.dispatch("loading/done");
        this.formAddress.reset();
        this.components = null;
        this.showBokking = true;
      }, 200);
    },
    saveAddressBook: async function () {
      const self = this;
      self.$store.dispatch("loading/start");

      const { data } = await self.formAddressNew.post(
        "/users/profiles/address/book"
      );
      self.loadAddressBook(data.data.id);

      Toast.fire({
        icon: "success",
        title: data.message,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.details-bar {
  border-bottom-color: rgb(#aaa, 0.5) !important;
  border-bottom-width: 0.5px !important;
  border-bottom: solid;
  z-index: 2;
}
.details-title-bar {
  font-size: 1.6rem !important;
  font-weight: 700 !important;
}
.details-content {
  padding-top: 100px !important;
}
.details-title {
  font-size: 2.5rem !important;
  font-weight: 800 !important;
}
.btn-text {
  font-size: 1.2rem !important;
  text-transform: none !important;
}
.list-item {
  background-color: white;
  border: solid;
  border-color: rgba(56, 56, 56, 0.2);
  border-width: 0.5px !important;
  border-radius: 5px;
}
.list-header-title {
  font-size: 1.2rem;
  color: black;
  font-weight: 800;
}
.list-text-title {
  font-size: 1.2rem;
  color: #000 !important;
}
.text-o-l-2 {
  display: -webkit-box !important;
  max-width: 100% !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
}
.list-text-subtitle {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.6);
}
.list-text-subtitle.error {
  font-size: 1rem;
  color: white;
  background-color: red;
}
.list-text-change {
  font-size: 0.9rem;
  color: var(--v-primary-base);
  font-weight: 700;
}
.no-deliverable {
  color: white;
  font-size: 1rem;
  font-weight: 700;
}
.no-deliverable-item {
  color: red;
  font-size: 1rem;
  font-weight: 700;
}
.list-item-height {
  height: 72px;
}
</style>
